import _ from 'lodash';
import angular from 'angular';
import ComponentsModule from '../components-module';
import template from './keyboard-shortcuts-modal.html';

const COMPONENT_NAME = 'KeyboardShortcutsModal';

const KeyboardShortcutsModal = ($rootScope, $uibModal, KeyboardShortcutService) => {

  const getShortcutsList = (shortcutSet) => {
    let list = Object.keys (shortcutSet.global)
      .reduce ((acc, key) => {
        if (shortcutSet.global[key]) {
          acc.push ({ key: KeyboardShortcutService.inferUserKey(key), description: shortcutSet.global[key] });
        }
        return acc;
      }, []);
    
    Object.keys (_.omit (shortcutSet, 'global')).forEach((key) => {
      if (shortcutSet[key]) {
        list.push ({ key: KeyboardShortcutService.inferUserKey(key), description: shortcutSet[key] });
      }
    });
    return list;
  };

  let _isOpen = false;
  const open = (parentScope, backdrop = true) => {
    
    if (_isOpen) {
      return;
    }

    const modalScope = $rootScope.$new(true, parentScope);
    modalScope.keyboardShortcuts = getShortcutsList (KeyboardShortcutService.describe ());

    const modal = $uibModal.open({
      animation: false,
      backdrop,
      keyboard: false,
      scope: modalScope,
      template,
      windowClass: 'keyboard-shortcuts-help ng-cloak',
      size: 'centered'
    });

    // Hm, result is resolved when modal is closed and rejected when modal is dismissed,
    // If one does not catch dismissed, angular prints warning...
    modal.result
      .then (() => {}, () => {}) 
      .finally (() => {
        modalScope.$destroy ();
        KeyboardShortcutService.pop();
        _isOpen = false;
      });

    _isOpen = true;

    modalScope.close = () => {
      modal.close();
    };

    KeyboardShortcutService.hideAndPush({
      'escape': {
        action: () => {
          modalScope.close();
        },
        label: 'keyboard-shortcuts-modal.close.label'
      }
    });

    
  };

  return { open };
};

angular.module (ComponentsModule).factory (COMPONENT_NAME, KeyboardShortcutsModal);
export default COMPONENT_NAME;
